import * as React from 'react';
import { cva } from 'class-variance-authority';

import { cn } from '@/lib/utils';

const LiveClassCard = React.forwardRef(({ className, variant, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('cursor-default flex flex-col p-3 gap-5 rounded-[10px] border border-solid border-neutral-lightest bg-white shadow-sm hover:shadow-md focus:shadow-md text-xs transition-all duration-150', className)}
    {...props}
  />
));
LiveClassCard.displayName = 'LiveClassCard';

const LiveClassCardHeader = React.forwardRef(({ className, variant, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('leading-none', className)}
    {...props}
  />
));
LiveClassCardHeader.displayName = 'LiveClassCardHeader';

const LiveClassCardHeaderInner = React.forwardRef(({ className, variant, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('flex justify-between mb-2', className)}
    {...props}
  />
));
LiveClassCardHeaderInner.displayName = 'LiveClassCardHeaderInner';

const LiveClassCardTitle = React.forwardRef(({ className, variant, ...props }, ref) => (
  <h3
    ref={ref}
    className={cn('text-primary-dark font-bold mb-0 inline-block max-w-full overflow-hidden text-ellipsis whitespace-nowrap', className)}
    {...props}
  />
));
LiveClassCardTitle.displayName = 'LiveClassCardTitle';

const LiveClassCardBody = React.forwardRef(({ className, variant, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('mb-0', className)}
    {...props}
  />
));
LiveClassCardBody.displayName = 'LiveClassCardBody';

const LiveClassCardTime = React.forwardRef(({ className, variant, ...props }, ref) => (
  <p
    ref={ref}
    className={cn('mb-0 flex items-center gap-1 text-neutral-dark text-xs font-light', className)}
    {...props}
  />
));
LiveClassCardTime.displayName = 'LiveClassCardTime';

const LiveClassCardFooter = React.forwardRef(({ className, variant, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('mb-0', className)}
    {...props}
  />
));
LiveClassCardFooter.displayName = 'LiveClassCardFooter';

export { LiveClassCard, LiveClassCardHeader, LiveClassCardHeaderInner, LiveClassCardTitle, LiveClassCardBody, LiveClassCardTime, LiveClassCardFooter };
